module.exports = __webpack_public_path__ + "static/index_image_2-3c030d61b0bec3a96a682102f1b82f9e.jpg";